export default __webpack_public_path__ + "static/media/Sara-Alfred.801597ef.png";